import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../../components/ui/pagination";
import { cn } from "../../libs/utils";

const PaginationV2 = ({ gotoPrev, gotoNext, gotoPage, paginationData, activePage, hasPrevious, hasNext }) => {
  return (
    <Pagination className="justify-start px-0 pt-0 pb-0">
      <PaginationContent className="gap-0">
        <PaginationItem>
          <PaginationPrevious
            onClick={gotoPrev}
            size="md"
            className={cn(hasPrevious ? "" : "active:opacity-50 focus:opacity-50 hover:opacity-50 opacity-50 cursor-not-allowed", "cursor-pointer")}
          />
        </PaginationItem>
        {paginationData?.map((item, index) => (
          <PaginationItem key={index}>
            <PaginationLink
              className={cn(
                "border-[0.5px] size-[37px] border-primary-40 cursor-pointer",
                item === activePage ? "bg-primary-10" : ""
              )}
              size="sm"
              onClick={() => {
                if (item === "...") {
                  return;
                }
                gotoPage(item)
              }}
            >
              {item}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem>
          <PaginationNext
            onClick={gotoNext}
            size="md"
            className={cn(hasNext ? "" : "active:opacity-50 focus:opacity-50 hover:opacity-50 opacity-50 cursor-not-allowed", "cursor-pointer")}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}

export default PaginationV2
